export class IdDescriptionName {
  public constructor(
      public readonly id: string,
      public readonly description: string,
      public readonly name: string
  ) { }
}

